import {store} from '../../redux/store';
import {hideDateRangePickerModal, showDateRangePickerModal} from './reducer';
import {DateRangePickerModalMessage} from '../../interfaces/connected-components/dateRangePicker';

/**
 * This function open DateRangePicker modal
 */
export const openDateRangePickerModal = ({
  onConfirm,
  currentRange,
  mode = 'single',
  datePickerProps,
}: DateRangePickerModalMessage) => {
  store.dispatch(
    showDateRangePickerModal({
      onConfirm,
      currentRange,
      mode,
      datePickerProps,
    }),
  );
};

/**
 * This function close DateRangePicker modal
 */
export const closeDateRangePickerModal = () => {
  store.dispatch(hideDateRangePickerModal());
};
